import { FC } from 'react';

import { AccountOverview } from '@bpm-web-app/components/src/lib/supreme-account/overview/account-overview';
import { AccountPageProps } from '@bpm-web-app/components/src/lib/supreme-account/account';

export const AccountOverviewPage: FC<AccountPageProps> = (props) => <AccountOverview {...props} />;

export default AccountOverviewPage;

export async function getStaticProps() {
    return {
        props: {
            title: 'Account Overview',
        },
    };
}
